/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash d3fb1621044f3c4775cf07bccb1d39ad */

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SignInWithEmailPasswordMutationInput = {
    email: string;
    password: string;
};
export type SignInScreenEmailPasswordFormMutationVariables = {
    input: SignInWithEmailPasswordMutationInput;
};
export type SignInScreenEmailPasswordFormMutationResponse = {
    readonly signInWithEmailPassword: {
        readonly __typename: "SignInWithEmailPasswordMutationSuccess";
        readonly accessToken: string;
        readonly refreshToken: string;
        readonly query: {
            readonly viewer: {
                readonly id: string;
                readonly " $fragmentRefs": FragmentRefs<"UserPrimaryPhoto_user">;
            } | null;
            readonly " $fragmentRefs": FragmentRefs<"AuthenticatedHomeScreen_query" | "DynamicIslandProfile_query">;
        };
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
};
export type SignInScreenEmailPasswordFormMutation = {
    readonly response: SignInScreenEmailPasswordFormMutationResponse;
    readonly variables: SignInScreenEmailPasswordFormMutationVariables;
};



/*
mutation SignInScreenEmailPasswordFormMutation(
  $input: SignInWithEmailPasswordMutationInput!
) {
  signInWithEmailPassword(input: $input) {
    __typename
    ... on SignInWithEmailPasswordMutationSuccess {
      accessToken
      refreshToken
      query {
        ...AuthenticatedHomeScreen_query
        ...DynamicIslandProfile_query
        viewer {
          id
          ...UserPrimaryPhoto_user
        }
        id
      }
    }
  }
}

fragment ActorItem_actor on Actor {
  __isActor: __typename
  __typename
  ... on User {
    ...UserItem_user_4qCZIv
  }
  ... on Guild {
    ...GuildItem_guild_U3Wpz
  }
}

fragment AttendEventButton_event on Event {
  rowId
  prettyUrl
  hasExternalUrl
  hasVenue
  myAttendance {
    status
    userId
    id
  }
  owner {
    __typename
    ... on Guild {
      myMembership {
        id
      }
    }
    ... on User {
      id
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment AuthenticatedHomeScreen_query on Query {
  viewer {
    firstName
    lastName
    ...UserPrimaryPhoto_user
    id
  }
  ...HomeScreenGuildsList_query
  ...HomeScreenEventsList_query
  ...HomeScreenPresentationsList_query
}

fragment DynamicIslandProfile_query on Query {
  viewer {
    slugId
    ...UserPrimaryPhoto_user
    id
  }
}

fragment EventCardAttendeesSection_event on Event {
  endAt
  attendingInPerson: eventAttendees(condition: {status: ATTENDING_IN_PERSON}, first: 5) {
    edges {
      node {
        user {
          primaryPhoto {
            id
          }
          ...UserPrimaryPhoto_user
          id
        }
        id
      }
      cursor
    }
    totalCount
  }
  attendingVirtually: eventAttendees(condition: {status: ATTENDING_VIRTUAL}, first: 5) {
    edges {
      node {
        user {
          primaryPhoto {
            id
          }
          ...UserPrimaryPhoto_user
          id
        }
        id
      }
      cursor
    }
    totalCount
  }
  waiting: eventAttendees(condition: {status: WAITING_IN_PERSON}, first: 5) {
    edges {
      node {
        user {
          ...UserPrimaryPhoto_user
          id
        }
        id
      }
      cursor
    }
    totalCount
  }
}

fragment EventCardPresentationsSection_event on Event {
  eventCardPresentations: presentations(first: 3, orderBy: [CREATED_AT_ASC, ID_ASC]) {
    edges {
      node {
        rowId
        presenterFirstName
        presenterLastName
        presenter {
          firstName
          lastName
          ...UserPrimaryPhoto_user
          id
        }
        id
      }
      cursor
    }
    totalCount
  }
}

fragment EventCard_event on Event {
  id
  rowId
  name
  slug
  prettyUrl
  startAt
  endAt
  timeZone
  myAttendance {
    id
  }
  visibility
  owner {
    __typename
    ...ActorItem_actor
    ... on User {
      isMe
    }
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  eventCardHasPresentations: presentations(first: 1, orderBy: [CREATED_AT_ASC, ID_ASC]) {
    totalCount
  }
  coverPhoto {
    ...GraphQLImage_image
    id
  }
  ...EventItem_event
  ...AttendEventButton_event
  ...EventCardPresentationsSection_event
  ...EventCardAttendeesSection_event
}

fragment EventItem_event on Event {
  id
  prettyUrl
  startAt
  endAt
  name
  description
  owner {
    __typename
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on User {
      isMe
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  ...AttendEventButton_event
  ...EventCardPresentationsSection_event
  ...EventCardAttendeesSection_event
  ...EventVisibilityCrumb_event
}

fragment EventVisibilityCrumb_event on Event {
  hasExternalUrl
  hasVenue
  visibility
}

fragment GraphQLImage_image on Image {
  url
}

fragment GuildCard_guild on Guild {
  slugId
  rowId
  name
  description
  type
  myMembership {
    membershipLevel
    id
  }
  ...GuildMembershipStatus_guild
  ...GuildJoinConfirmationContent_guild
  ...GuildPrimaryPhoto_guild
  primaryPhoto {
    id
  }
  backgroundPhoto {
    ...GraphQLImage_image
    id
  }
}

fragment GuildItem_guild_U3Wpz on Guild {
  slugId
  name
  ...GuildMembershipStatus_guild_U3Wpz
  ...GuildPrimaryPhoto_guild
}

fragment GuildJoinConfirmationContent_guild on Guild {
  name
  rowId
  slugId
}

fragment GuildMembershipStatus_guild on Guild {
  myMembership {
    membershipLevel
    id
  }
  networkMembers {
    totalCount
  }
}

fragment GuildMembershipStatus_guild_U3Wpz on Guild {
  myMembership {
    membershipLevel
    id
  }
  networkMembers {
    totalCount
  }
}

fragment GuildPrimaryPhoto_guild on Guild {
  type
  primaryPhoto {
    ...GraphQLImage_image
    id
  }
}

fragment HomeScreenEventsList_query on Query {
  upcomingEvents: eventsByTimeSelection(first: 4, timeSelection: UPCOMING) {
    edges {
      node {
        id
        ...EventCard_event
      }
    }
  }
  pastEvents: eventsByTimeSelection(first: 4, timeSelection: PAST) {
    edges {
      node {
        id
        ...EventCard_event
      }
    }
  }
}

fragment HomeScreenGuildsList_query on Query {
  guilds: rankedGuilds(guildType: GUILD, first: 4) {
    edges {
      node {
        ...GuildCard_guild
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment HomeScreenPresentationsList_query on Query {
  presentations(first: 4, orderBy: [CREATED_AT_DESC, ID_ASC]) {
    edges {
      node {
        id
        ...PresentationCard_presentation
      }
    }
  }
}

fragment PresentationCard_presentation on Presentation {
  rowId
  description
  prettyUrl
  title
  videoSourceUrl
  presenterFirstName
  presenterLastName
  presenter {
    ...UserItem_user
    id
  }
}

fragment UserDefaultPhoto_user on User {
  rowId
  emailMd5
}

fragment UserFollowingStatus_user_4qCZIv on User {
  followerCount
  isMe
  isFollowing
}

fragment UserItem_user on User {
  slugId
  firstName
  lastName
  followerCount
  ...UserPrimaryPhoto_user
  ...UserFollowingStatus_user_4qCZIv
}

fragment UserItem_user_4qCZIv on User {
  slugId
  firstName
  lastName
  followerCount
  ...UserPrimaryPhoto_user
  ...UserFollowingStatus_user_4qCZIv
}

fragment UserPrimaryPhoto_user on User {
  ...UserDefaultPhoto_user
  primaryPhoto {
    ...GraphQLImage_image
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accessToken",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refreshToken",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailMd5",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v11 = [
  (v10/*: any*/),
  (v5/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v14 = {
  "kind": "Literal",
  "name": "first",
  "value": 4
},
v15 = [
  (v14/*: any*/),
  {
    "kind": "Literal",
    "name": "guildType",
    "value": "GUILD"
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "GuildMembership",
  "kind": "LinkedField",
  "name": "myMembership",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "membershipLevel",
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v21 = [
  (v20/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "UsersConnection",
  "kind": "LinkedField",
  "name": "networkMembers",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyUrl",
  "storageKey": null
},
v25 = [
  (v13/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "followerCount",
    "storageKey": null
  },
  (v8/*: any*/),
  (v9/*: any*/),
  (v12/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isMe",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFollowing",
    "storageKey": null
  },
  (v5/*: any*/)
],
v26 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": [
    "CREATED_AT_ASC",
    "ID_ASC"
  ]
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterFirstName",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterLastName",
  "storageKey": null
},
v29 = {
  "kind": "Literal",
  "name": "first",
  "value": 5
},
v30 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EventAttendeesEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EventAttendee",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "primaryPhoto",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              (v9/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      (v23/*: any*/)
    ],
    "storageKey": null
  },
  (v20/*: any*/)
],
v31 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EventsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v8/*: any*/),
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          (v24/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeZone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EventAttendee",
            "kind": "LinkedField",
            "name": "myAttendance",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "visibility",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isActor"
              },
              {
                "kind": "InlineFragment",
                "selections": (v25/*: any*/),
                "type": "User",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v13/*: any*/),
                  (v16/*: any*/),
                  (v19/*: any*/),
                  (v22/*: any*/),
                  (v18/*: any*/),
                  (v12/*: any*/)
                ],
                "type": "Guild",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          },
          {
            "alias": "eventCardHasPresentations",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              },
              (v26/*: any*/)
            ],
            "concreteType": "PresentationsConnection",
            "kind": "LinkedField",
            "name": "presentations",
            "plural": false,
            "selections": (v21/*: any*/),
            "storageKey": "presentations(first:1,orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "coverPhoto",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasExternalUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasVenue",
            "storageKey": null
          },
          {
            "alias": "eventCardPresentations",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 3
              },
              (v26/*: any*/)
            ],
            "concreteType": "PresentationsConnection",
            "kind": "LinkedField",
            "name": "presentations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PresentationsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Presentation",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "presenter",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v12/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              (v20/*: any*/)
            ],
            "storageKey": "presentations(first:3,orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
          },
          {
            "alias": "attendingInPerson",
            "args": [
              {
                "kind": "Literal",
                "name": "condition",
                "value": {
                  "status": "ATTENDING_IN_PERSON"
                }
              },
              (v29/*: any*/)
            ],
            "concreteType": "EventAttendeesConnection",
            "kind": "LinkedField",
            "name": "eventAttendees",
            "plural": false,
            "selections": (v30/*: any*/),
            "storageKey": "eventAttendees(condition:{\"status\":\"ATTENDING_IN_PERSON\"},first:5)"
          },
          {
            "alias": "attendingVirtually",
            "args": [
              {
                "kind": "Literal",
                "name": "condition",
                "value": {
                  "status": "ATTENDING_VIRTUAL"
                }
              },
              (v29/*: any*/)
            ],
            "concreteType": "EventAttendeesConnection",
            "kind": "LinkedField",
            "name": "eventAttendees",
            "plural": false,
            "selections": (v30/*: any*/),
            "storageKey": "eventAttendees(condition:{\"status\":\"ATTENDING_VIRTUAL\"},first:5)"
          },
          {
            "alias": "waiting",
            "args": [
              {
                "kind": "Literal",
                "name": "condition",
                "value": {
                  "status": "WAITING_IN_PERSON"
                }
              },
              (v29/*: any*/)
            ],
            "concreteType": "EventAttendeesConnection",
            "kind": "LinkedField",
            "name": "eventAttendees",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EventAttendeesEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventAttendee",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v12/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              (v20/*: any*/)
            ],
            "storageKey": "eventAttendees(condition:{\"status\":\"WAITING_IN_PERSON\"},first:5)"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SignInScreenEmailPasswordFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "signInWithEmailPassword",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Query",
                "kind": "LinkedField",
                "name": "query",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "UserPrimaryPhoto_user"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AuthenticatedHomeScreen_query"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DynamicIslandProfile_query"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "SignInWithEmailPasswordMutationSuccess",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SignInScreenEmailPasswordFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "signInWithEmailPassword",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Query",
                "kind": "LinkedField",
                "name": "query",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v12/*: any*/),
                      (v5/*: any*/),
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "guilds",
                    "args": (v15/*: any*/),
                    "concreteType": "GuildsConnection",
                    "kind": "LinkedField",
                    "name": "rankedGuilds",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GuildsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Guild",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v8/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v22/*: any*/),
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "backgroundPhoto",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              },
                              (v5/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v23/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasNextPage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "rankedGuilds(first:4,guildType:\"GUILD\")"
                  },
                  {
                    "alias": "guilds",
                    "args": (v15/*: any*/),
                    "filters": [
                      "guildType"
                    ],
                    "handle": "connection",
                    "key": "HomeScreenGuildsList_query_guilds",
                    "kind": "LinkedHandle",
                    "name": "rankedGuilds"
                  },
                  {
                    "alias": "upcomingEvents",
                    "args": [
                      (v14/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "timeSelection",
                        "value": "UPCOMING"
                      }
                    ],
                    "concreteType": "EventsConnection",
                    "kind": "LinkedField",
                    "name": "eventsByTimeSelection",
                    "plural": false,
                    "selections": (v31/*: any*/),
                    "storageKey": "eventsByTimeSelection(first:4,timeSelection:\"UPCOMING\")"
                  },
                  {
                    "alias": "pastEvents",
                    "args": [
                      (v14/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "timeSelection",
                        "value": "PAST"
                      }
                    ],
                    "concreteType": "EventsConnection",
                    "kind": "LinkedField",
                    "name": "eventsByTimeSelection",
                    "plural": false,
                    "selections": (v31/*: any*/),
                    "storageKey": "eventsByTimeSelection(first:4,timeSelection:\"PAST\")"
                  },
                  {
                    "alias": null,
                    "args": [
                      (v14/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": [
                          "CREATED_AT_DESC",
                          "ID_ASC"
                        ]
                      }
                    ],
                    "concreteType": "PresentationsConnection",
                    "kind": "LinkedField",
                    "name": "presentations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PresentationsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Presentation",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v8/*: any*/),
                              (v17/*: any*/),
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "videoSourceUrl",
                                "storageKey": null
                              },
                              (v27/*: any*/),
                              (v28/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "presenter",
                                "plural": false,
                                "selections": (v25/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "presentations(first:4,orderBy:[\"CREATED_AT_DESC\",\"ID_ASC\"])"
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "SignInWithEmailPasswordMutationSuccess",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "cebd02c4cd6927bee3f252f9f5d11eff245d934b900bf1e423d62984e93d67f9",
    "metadata": {},
    "name": "SignInScreenEmailPasswordFormMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = '6aafed0fc3381d3df5caaa586d3ee245';
export default node;
